import { Component, DestroyRef, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectService } from '../services/project.service';
import { map, skip } from 'rxjs';
import { UserService } from '../services/user.service';
import { ProjectModalsComponent } from '../shared/project-modals/project-modals.component';
import { Project } from '../models/project.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: false
})
export class HomeComponent {
  @ViewChild('projectModals') private projectModals!: ProjectModalsComponent;
  protected projects: Project[] = [];
  private readonly destroyRef = inject(DestroyRef);
  protected areProjectsLoading = false;

  private user = this.userService.createDefaultUser();

  constructor(
    private readonly router: Router,
    private readonly projectService: ProjectService,
    private readonly userService: UserService
  ) {}

  ngOnInit(): void {
    this.areProjectsLoading = true;
    this.userService.user$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(user => (this.user = user));

    this.projectService.projects$
      .pipe(
        skip(1),
        map(projects => projects.filter(project => project.owner === this.user.email)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(projects => {
        this.projects = projects;
        this.areProjectsLoading = false;
      });

    this.projectService.getProjects();
  }

  async addProject() {
    this.projectModals.addProject();
  }

  async editProject(selectedProject: Project) {
    this.projectModals.editProject(selectedProject);
  }

  async openDeleteModal(project: Project) {
    this.projectModals.openDeleteModal(project);
  }

  startCalculation(id: number) {
    this.router.navigate(['/projects', id]);
  }
}
